import { useEffect, useState } from 'react'

import { Space } from '@tribeplatform/gql-client/types'
import { useAdminOnboarding } from '@tribeplatform/react-components/AdminOnboarding'
import { SpacePicker } from '@tribeplatform/react-components/EntityPicker'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useNetwork, useUpdateNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const DefaultSpacesSettings = () => {
  const { $t } = useI18n()
  const { mutateAsync: updateNetwork, isLoading } = useUpdateNetwork()
  const { completeStep } = useAdminOnboarding()

  const { data: network } = useNetwork({
    fields: {
      defaultSpaces: {
        image: 'all',
      },
    },
  })

  const [spaces, setSpaces] = useState<Space[]>(null)
  useEffect(() => {
    if (!spaces) {
      setSpaces(network?.defaultSpaces)
    }
  }, [network, spaces])

  return (
    <Card>
      <Card.Header
        title={$t({
          defaultMessage: 'Default {SPACES}',
          id: 'Admin.DefaultSpaces',
        })}
        description={$t({
          defaultMessage:
            'Select which {SPACES} you want new {MEMBERS} to be automatically added to.',
          id: 'Admin.DefaultSpaces.Description',
        })}
      />
      <Card.Content>
        <div className="flex flex-col space-y-5">
          <SpacePicker onChange={setSpaces} value={spaces} multiple />
          <div className="flex justify-end">
            <Button
              loading={isLoading}
              onClick={async () => {
                try {
                  await updateNetwork({
                    input: {
                      defaultSpaceIds: spaces.map(space => space.id),
                    },
                  })
                  completeStep({
                    step: 'permission-and-privacy',
                  })
                  toast({
                    title: $t({
                      defaultMessage: 'Default {SPACES} updated',
                      id: 'Admin.DefaultSpaces.Updated',
                    }),
                    status: 'success',
                  })
                } catch (e) {
                  toast({
                    title: $t({
                      defaultMessage: 'Unable to update default {SPACES}',
                      id: 'Admin.DefaultSpaces.FailedToUpdate',
                    }),
                    status: 'error',
                  })
                }
              }}
            >
              <T defaultMessage="Update" id="Generics.Update" />
            </Button>
          </div>
        </div>
      </Card.Content>
    </Card>
  )
}
